module.exports = __webpack_public_path__ + "img/hand-thumbs-down-fill.69fdf73b.svg";